import React, { Component } from "react";
import { Table, Button, Message, Label } from "semantic-ui-react";
import { Link } from "react-router-dom";

class PayablePrintReport extends Component {
  render() {
    const { transactions, total } = this.props;
    return (
      <Table celled fixed singleLine>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell colSpan="7" style={{ textAlign: "center" }}>
              Payable Report
            </Table.HeaderCell>
          </Table.Row>

          <Table.Row>
            {/* <Table.HeaderCell width={2}>Date</Table.HeaderCell> */}
            <Table.HeaderCell width={1} style={{ textAlign: "center" }}>
              Sr.
            </Table.HeaderCell>
            <Table.HeaderCell width={4}>Name</Table.HeaderCell>
            <Table.HeaderCell width={2} style={{ textAlign: "center" }}>
              Type
            </Table.HeaderCell>
            <Table.HeaderCell width={3}>Mobile</Table.HeaderCell>
            <Table.HeaderCell width={2} style={{ textAlign: "center" }}>
              Amount
            </Table.HeaderCell>
            <Table.HeaderCell width={2} style={{ textAlign: "center" }}>
              Paid
            </Table.HeaderCell>
            <Table.HeaderCell
              width={2}
              style={{ textAlign: "center", whiteSpace: "pre-line" }}
            >
              Balance Amount
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {transactions.map((transaction) => (
            <Table.Row>
              <Table.Cell style={{ textAlign: "center" }}>
                {transaction.sr}
              </Table.Cell>
              <Table.Cell>
                <Link to={`${transaction.url}`}>{transaction.name}</Link>
              </Table.Cell>
              <Table.Cell style={{ textAlign: "center" }}>
                {transaction.type}
              </Table.Cell>
              <Table.Cell style={{ whiteSpace: "pre-line" }}>
                {transaction.mobile}
              </Table.Cell>
              <Table.Cell style={{ textAlign: "center" }}>
                {transaction.amount}
              </Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
            </Table.Row>
          ))}

          <Table.Row>
            <Table.Cell style={{ textAlign: "center" }}></Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell style={{ textAlign: "center" }}></Table.Cell>
            <Table.Cell style={{ fontSize: "15px", fontWeight: "bold" }}>
              Total Payable Report
            </Table.Cell>
            <Table.Cell
              style={{
                textAlign: "center",
                fontSize: "15px",
                fontWeight: "bold",
              }}
            >
              <b>{total}</b>
            </Table.Cell>
            <Table.Cell colspan="2"></Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}
export default PayablePrintReport;
